import WelcomePageButtonBox from "../../atoms/wrapper/welcomePageButtonBox.styled";
import WelcomePageText from "../../melecules/welcomePageText";
import BookAppointmentButton from "../../atoms/buttons/bookAppointmentButton/bookAppointmentButton";
import FaqButton from "../../atoms/buttons/faqButton/faqButton";
import ToChatButton from "../../atoms/buttons/toChatButton/toChatButton";
import GenesysLoadErrorNotice from "../../melecules/genesysLoadErrorNotice";
import React from "react";
import { AppContext, GenesysStatus } from "../../../store/genesys.context";
import type { Brand } from "../../../lib/ChatbotConfig";

const WelcomePage = (): React.JSX.Element => {
  const {
    brand,
    genesysStatus,
    retryGenesysLoad,
  }: {
    brand: Brand;
    genesysStatus: GenesysStatus;
    retryGenesysLoad: () => void;
  } = React.useContext(AppContext);

  return (
    <React.Fragment>
      <WelcomePageText />

      <WelcomePageButtonBox>
        {genesysStatus === "error" ? (
          <GenesysLoadErrorNotice onRetry={retryGenesysLoad} />
        ) : (
          <ToChatButton />
        )}

        {/* Show these buttons only for the training brand */}
        {brand === "training" && (
          <React.Fragment>
            <BookAppointmentButton />
            <FaqButton />
          </React.Fragment>
        )}
      </WelcomePageButtonBox>
    </React.Fragment>
  );
};

export default WelcomePage;
